<template>
  <div class="home-page flex-wrap flex-vertical">
    <div>222</div>
    <v-map-driving
      ref="mapDriving"
      :myPosition="myPositionCenter"
      :destination="curClientDetails"
      @backHandle="pushUserLog('路线导航-返回')"
    ></v-map-driving>
  </div>
</template>

<script>
import VMapDriving from '@/components/VMapDriving.vue'
export default {
  name: 'mapDrive',
  components: {
    VMapDriving // 高德地图路线规划组件
  },
  data () {
    return {
      myPositionCenter: '',
      curClientDetails: {} // 当前终端详情数据
    }
  },
  computed: {
  },
  mounted () {
    console.log(22, this.$route.query)
    this.myPositionCenter = this.$route.query.myPositionCenter
    this.curClientDetails = this.$route.query.curClientDetails
    this.$nextTick(() => {
      this.$refs.mapDriving.show()
    })
  }
}
</script>

<style scoped>
</style>
